<template>
	<div class="exercise exercise-book">
		<div class="ss-breadcrumb">
			<div class="container-hts">
				<ul class="margin-0 p-0">
					<li><router-link to="/exercise">Sách điện tử</router-link></li>
					<li>Luyện tập theo sách</li>
				</ul>
			</div>
	    </div>
	    <div class="ss-banner ss-banner--exercise ss-banner--not-img">
	    	<div class="container-hts">
	    		<div class="ss-banner__classes">
					<span class="ss-banner__classes__name">Lớp</span>
					<ul class="ss-banner__classes__list p-0 margin-0">
						<li><a href="javascript:;" class="active">01</a></li>
						<li><a href="javascript:;">02</a></li>
						<li><a href="javascript:;">03</a></li>
						<li><a href="javascript:;">04</a></li>
						<li><a href="javascript:;">05</a></li>
					</ul>
	    		</div>
	    	</div>
	    </div>
	    <div class="ss-data">
	    	<div class="container-hts">
		    	<div class="list__box list__box--book">
		    		<div class="list__box__body p-0">
		    			<div class="exercise__book position-rel">
		    				<div class="row">
			    				<div class="item col-lg-3 col-sm-6 col-md-4" v-for="(item, index) of books">
			    					<div class="item__wrap position-rel text-center">
			    						<div class="item__head">
			    							<router-link :to="{name: 'exerciseDetail', params: {slug: item.slug, id: item.bookId}}">
			    								<img :src="item.imageUrl ? `${cdnUrl}${item.imageUrl}` : img404" :alt="item.name">
			    							</router-link>
			    						</div>
			    						<div class="item__body">
			    							<h3 class="item__name font-size-16 font-sanpro-semibold primary-color-txt">
			    								<router-link :to="{name: 'exerciseDetail', params: {slug: item.slug, id: item.bookId}}" class="primary-color-txt">
			    									{{ item.name }}
			    								</router-link>
			    							</h3>
			    							<p class="margin-0 secondary-color-txt font-size-14">Tái bản: {{ item.editionYear }}</p>
			    						</div>
			    					</div>
				    			</div>
		    				</div>
		    			</div>
		    		</div>
		    	</div>
		    </div>
	    </div>
	</div>
</template>

<script>
  	import 'swiper/dist/css/swiper.css';
  	import { APP_CONFIG } from '@/utils/constants';
  	const img404 = require('@/assets/images/img_404.jpg');

	export default {
		name: 'ExerciseEbook',

		data() {
			return {
		    	img404,
		    	cdnUrl: APP_CONFIG.cdnurl,
		    	books: [
		    		{bookId: 1, name: 'Bài tập môn toán 1', imageUrl: '', editionYear: 2020, slug: 'bai-tap-mon-toan-1'},
		    		{bookId: 2, name: 'Bài tập môn toán 2', imageUrl: '', editionYear: 2020, slug: 'bai-tap-mon-toan-2'},
		    		{bookId: 3, name: 'Bài tập môn toán 3', imageUrl: '', editionYear: 2020, slug: 'bai-tap-mon-toan-3'},
		    		{bookId: 4, name: 'Bài tập môn toán 4', imageUrl: '', editionYear: 2020, slug: 'bai-tap-mon-toan-4'},
		    		{bookId: 5, name: 'Bài tập môn toán 4', imageUrl: '', editionYear: 2020, slug: 'bai-tap-mon-toan-5'},
		    	]
		    };
		},
	};
</script>

<style lang="scss" scoped>
	.exercise-book {
		// .ss-banner {
		// 	padding: 50px 0
		// }
		.ss-data {
			padding: 25px 0 0;

			.item {
				margin-bottom: 30px;
			}
		}
	}
</style>
